/*
 * 全局配置脚本
 */

import resourceSubject from 'next/javascripts/reactivity/resource-subject';

(function($) {

$(function() {
    tower.lastUpdated = moment();

    tower.componentPrototypes = {};

    simple.util.preloadImages([
        require('images/blank.gif'),
        require('images/tiny-loading.gif')
    ]);

    tower.me = {
        id: $('#member-id').val(),
        userId: $('input#user-id[type="hidden"]').val(),
        guid: $( "#member-guid" ).val(),
        nickname: $( "#member-nickname" ).val(),
        avatar: $('#member-avatar').val(),
        admin: $( "#member-admin" ).length > 0 ? true : false,
        owner: $( '#member-owner' ).length > 0 ? true : false,
        visitor: $( '#member-visitor' ).length > 0 ? true : false,
        tz: $('#member-timezone').val() || 'Asia/Shanghai'
    };

    tower.team = {
        id: $('#team-id').val(),
        guid: $('#team-guid').val(),
        name: $('#team-name').val(),
        securityWatermark: $('#team-security-watermark').val(),
        enablePusher: true
    };

    tower.fileCenter = process.env.FILE_CENTER_URI_BASE;
    tower.ossAssetsEndpoint = process.env.OSS_ASSETS_ENDPOINT;

    if (typeof gon != 'undefined') {
        tower.d18n_enabled = gon.d18n_enabled;
        tower.d18n_muted = gon.d18n_muted;
        tower.resource_card_path = gon.resource_card_path;

        if (gon.permissions) {
            tower.permissions = gon.permissions;
            delete gon.permissions;
        }

        if (gon.triggered_guides) {
            tower.triggered_guides = gon.triggered_guides;
            delete gon.triggered_guides;
        }
    }

    // preload self avatar for running todo's runner animation
    if (tower.me.avatar) {
        simple.util.preloadImages(tower.me.avatar);
    }

    // set the moment.js global locale
    moment.locale('zh-cn');

    // ajax global setup and events
    $.ajaxSetup({
        type: "POST",
        dataType: "json",
        headers: { "Twr-Canary-Host": process.env.IS_CANARY_UPSTREAM ? process.env.HOST : undefined },
        data: {
            conn_guid: $( "#conn-guid" ).val()
        },
        error: function(xhr, status, code) {
            tower.handleErrorResponse(xhr);
        }
    });

    // global ajax event
    $(document).ajaxSend(function(e, xhr, settings) {
        if (settings.type !== 'GET') {
            var token = $('meta[name=csrf-token]').attr('content');
            xhr.setRequestHeader('X-CSRF-Token', token);
        }
    }).ajaxComplete(function(e, xhr, settings) {
        var token = xhr.getResponseHeader('X-CSRF-Token');
        if (token) {
            $('meta[name=csrf-token]').attr({
                content: token
            });
        }
    }).on('ajax:error', function(e, xhr) {
        tower.handleErrorResponse(xhr);
    });

    // update unread notifications count
    if ($('#notification-count').length) {
      tower.updateNoticeCount($('#notification-count').data('unread-count'));
    }

    // 方便针对 IE 编写特殊的 css
    if (navigator.userAgent.toLowerCase().indexOf('msie') >= 0) {
        $('html').addClass('ie');
    }

    tower.guideSubject = resourceSubject('user-guide');

    // global watermark
    if (tower.team.securityWatermark === "true") {
        gwm.creation({
            txt: tower.me.nickname + " " + tower.me.id,
            width: 198,
            height: 140,
            x: 20,
            y: 70,
            fontSize: 13,
            color: '#999999',
            container: '.workspace',
            css: { "z-index": 9999, "pointer-events": "none" },
            watch: true
        });
    }
});

if ('undefined' === typeof window.tower || null === window.tower) {
    window.tower = {}
}
window.tower.members = {}

})( jQuery );
